import api from './api';

/**
 * Servicio para gestionar empresas
 */
export const empresasService = {
  /**
   * Obtener todas las empresas
   */
  getAll: async () => {
    const response = await api.get('/empresas');
    return response;
  },

  /**
   * Obtener una empresa por ID
   */
  getById: async (id) => {
    const response = await api.get(`/empresas/${id}`);
    return response;
  },

  /**
   * Crear una nueva empresa
   */
  create: async (empresa) => {
    const response = await api.post('/empresas', empresa);
    return response;
  },

  /**
   * Actualizar una empresa
   */
  update: async (id, empresa) => {
    const response = await api.put(`/empresas/${id}`, empresa);
    return response;
  },

  /**
   * Desactivar una empresa (baja lógica)
   */
  delete: async (id) => {
    const response = await api.delete(`/empresas/${id}`);
    return response;
  },
};

